import {
  Autocomplete as MantineAutocomplete,
  type AutocompleteProps,
} from "@mantine/core";
import { forwardRef, useMemo } from "react";
import {
  normalizeAutocompleteData,
  normalizeSelectData,
} from "src/utils/mantineComboboxData";

export type { AutocompleteProps };

const Autocomplete = forwardRef<HTMLInputElement, AutocompleteProps>(
  ({ data, ...props }, ref) => {
    const normalizedData = useMemo(() => {
      if (!data?.length) return [];
      const first = data[0];
      if (typeof first === "object" && first !== null && "label" in first) {
        return normalizeSelectData(data);
      }
      return normalizeAutocompleteData(data);
    }, [data]);

    return <MantineAutocomplete {...props} ref={ref} data={normalizedData} />;
  },
);

Autocomplete.displayName = "Autocomplete";

export default Autocomplete;
